import { createInitialGraphDFS } from './GraphLayout';
import { buildNavigationEdges } from './flowEdgeUtils';
import { applyStoredLayout } from './workflowFlowLayoutStorage';

export function countNavigationActions(workflowSteps) {
  if (!Array.isArray(workflowSteps) || workflowSteps.length === 0) return 0;

  return workflowSteps.reduce((count, step) => {
    const navCount = (step?.actions || []).filter(
      (action) => action?.type === 'navigation' && action?.link
    ).length;
    return count + navCount;
  }, 0);
}

/**
 * Build React Flow edges from workflow_steps (source of truth for navigation links).
 */
export function deriveEdgesFromWorkflowSteps(workflowSteps) {
  return buildNavigationEdges(workflowSteps || []);
}

/**
 * Merge derived edges with any in-progress proximity preview edges.
 */
export function mergeDerivedEdgesWithTemp(derivedEdges, currentEdges) {
  const tempEdges = (currentEdges || []).filter((edge) => edge.className === 'temp');
  if (tempEdges.length === 0) return derivedEdges;
  return [...derivedEdges, ...tempEdges];
}

export function syncFlowGraphFromSteps(workflow, showDetailedContent, setNodes, setEdges) {
  if (!workflow?.workflow_steps?.length) {
    setNodes([]);
    setEdges([]);
    return;
  }

  const { layoutNodes } = createInitialGraphDFS(
    workflow.workflow_steps,
    showDetailedContent
  );
  const layoutEdges = deriveEdgesFromWorkflowSteps(workflow.workflow_steps);

  setNodes(applyStoredLayout(layoutNodes, workflow));
  setEdges(layoutEdges);
}
